import { useContext } from 'react';
import PropTypes from 'prop-types';

import { useRouter } from 'app/helpers/routing';
import Context from '@bibliocommons/context';

import { writeSessionStorageItem } from 'app/helpers/storage';
import useIsomorphicLayoutEffect from 'app/hooks/useIsomorphicLayoutEffect';

export default function BackToLinkManager({ href, label, pageId, screenReaderLabel }) {
  const { setBackToLinkEnabled, backToLinkEnabled } = useContext(Context);
  const { location } = useRouter();
  const backToLinkHref = href || location.pathname + location.search;

  useIsomorphicLayoutEffect(() => {
    setBackToLinkEnabled(true);
  }, [setBackToLinkEnabled]);

  if (backToLinkEnabled) {
    writeSessionStorageItem('backToLink', { href: backToLinkHref, label, pageId, screenReaderLabel });
  }

  return null;
}

BackToLinkManager.propTypes = {
  href: PropTypes.string,
  label: PropTypes.string,
  pageId: PropTypes.string.isRequired,
  screenReaderLabel: PropTypes.string
};
